<template>
  <div class="menu-item menu-root-item" @mouseover="itemOver($event)" @mouseout="itemOut($event)">
    <Flex column w-full>
      <Flex w-full py-2 justify-between @click.prevent.stop="itemClicked()">
        <Icon
          :title="hideLabel ? item.label : undefined"
          :src="itemIcon(item)"
          class="menu-root-item-icon"
        />
        <Flex label v-html="item.label" />
      </Flex>
    </Flex>
  </div>
</template>

<script>
import Flex from '@wizer/core/components/flex/Flex'
import Icon from '@wizer/core/components/icon/Icon'
import MenuItemMixin from '@/mixins/MenuItemMixin'

export default {
  name: 'MenuRootItem',

  mixins: [MenuItemMixin],

  components: {
    Flex,
    Icon,
  },

  props: {
    item: {},
    hideLabel: Boolean,
  },

  methods: {
    itemIcon(item) {
      if (item.icon) {
        return item.icon
      }
      return null
    },
  },
}
</script>

<style scoped lang="postcss">
.menu-root-item {
  @apply w-full cursor-pointer overflow-hidden;
  min-height: 2.5rem;
}
.menu-root-item.active,
.menu-root-item:hover {
  @apply bg-primary-500 text-white;
}
.menu-root-item-icon {
  @apply text-xl;
  margin: 0.1rem 1.25rem;
}
.label {
  @apply w-0 h-0 opacity-0;
  padding: 0.1rem 0;
}
</style>

<style lang="postcss">
.panel:not(.collapsed) .menu-root-item .label {
  @apply w-11/12 opacity-100;
  transition: 1s;
}
</style>
